<template>
	<div class="upload__preview">
		<upload-header
			:title="$t(`upload.preview.title.${type}`)"
			:subtitle="media.name"
		/>

		<div class="upload__preview-container">
			<img
				v-if="type === 'image' && media && media.url"
				:src="media.url"
				class="upload__image-preview"
			>

			<vue-plyr
				v-if="type === 'video' && media && media.url"
				class="upload__video-preview"
			>
				<div class="plyr__video-embed">
					<iframe
						:src="videoUrl"
						allow="autoplay"
					/>
				</div>
			</vue-plyr>

			<upload-footer class="footer--preview">
				<helio-button
					:text="$t('upload.preview.close')"
					@click.stop="$emit('close')"
				/>
			</upload-footer>
		</div>
	</div>
</template>

<script>
import Button from '../../../button/Button.vue';
import Footer from '../../footer/Footer.vue';
import Header from '../../header/Header.vue';

export default {
	components: {
		'helio-button': Button,
		'upload-footer': Footer,
		'upload-header': Header,
	},
	props: {
		media: {
			type: Object,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
	},
	computed: {
		videoUrl() {
			if (this.media.url.includes('youtube.com')) {
				const params = '?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1';
				return `${this.media.url}${params}`;
			}

			if (this.media.url.includes('vimeo.com')) {
				const params = '?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media';
				const id = this.media.url.replace('https://vimeo.com/', '');
				return `https://player.vimeo.com/video/${id}${params}`;
			}

			return null;
		},
	},
};
</script>

<style lang="scss" src="./preview.scss" />
